// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"27163c0b","251":"1a34f502","419":"dfc35a8e","421":"c47a909a","453":"00c8947f","472":"800f9e48","502":"9b509f4c","557":"de334c0a","563":"d1a1ccef","606":"54687c80","641":"cbe0616c","863":"a37f41b8","990":"1a1954d8"}[chunkId] + ".chunk.js";
};